import { get } from 'pc-sales/utils/http';
import config from './config';
import { languages } from 'common/i18n';
import ControlApi from 'common/api/control';
import Formatter from 'common/utils/formatter';
class Statics {
    readonly sourceMap: {
        [key: string]: string
    } = {
            banks: '/global/banks_20200421.json',
            digital: '/global/digital_currency.json',
            currency: '/global/currency0417.json',
            locationDetail: '/global/location20191016.json',
        };

    private DEFALUTCOUNTRY = ['1', '81', '71', '82', 'KOR']; // 前两位为‘国家无省’/‘国家简体-无城市’
    /**
 *
 * @param sort 需要排到前几位的国家
 * @param list 默认的国家
 */

    formatCountry = (sort: Array<string>, list: Array<any>) => {
        // 修改国家顺序，将中国大陆、中国台湾、中国香港、中国澳门、韩国排前五位
        const len = sort.length;
        const items: Array<any> = [];

        const idx = (list: Array<any>, countryKey: string) => list.findIndex((l: any, i: number) => l.countryKey === countryKey);

        for (let i = 0; i < len; i++) {
            const index = idx(list, sort[i]);
            if (index > -1) {
                const item = list.splice(index, 1)[0];
                items.push(item);
            }
        }
        return [...items, ...list];
    }

    /**
 * 对国家列表按照首字母以拼音顺序/英语字母排序
 * @param type 语言类型
 * @param list 国家列表
 * @returns 按照规则排序的国家列表
 */
    sortByLang = (type: string, list: Array<any>) => {
        if (type === 'zh-CN' || type === 'zh-TW') {
            return list.sort(({ name: lastName }, { name: nextName }) => {
                return lastName.localeCompare(nextName, 'zh');
            });
        } else if (type === 'en-US') {
            return list.sort(({ name: lastName }, { name: nextName }) => {
                return lastName.localeCompare(nextName);
            });
        } else {
            return list;
        }
    }

    private config: any = {};
    /**
     * 获取配置
     */
    get = (key: string, callback: Function, lang?: string) => {
        if (this.config[key]) return callback(this.config[key]);
        // const lag = Formatter.lagName.getLagName('country');
        key === 'area' && ControlApi.country({ lang: languages.getDefault() }).then((country: any) => {
            this.config[key] = country;
            callback(country);
        });
        key === 'phoneCodes' && ControlApi.country({ lang: languages.getDefault() }).then((list: any) => {
            const options = list.map(({phoneCode, id, label }: any) => ({value: phoneCode, key: id, name: label}));
            this.config[key] = options;
            callback(options);
        });
        key === 'banks' && get('/v2/control/bank', { page: '1', pagesize: '0' }).then((data: any) => {
            const lag = Formatter.lagName.getLagName('bank');
            const options = data.data.map((val: any) => {
                return { label: val[lag] || val.bank_name_en, value: `${val.country_key}${val.key}`, key: val.bank_id };
            }).filter((val: any) => val);
            this.config[key] = options;
            callback(options);
        });
        if ((key != 'area') && (key != 'banks') && (key != 'location') && (key != 'phoneCodes')) {
            this.config[key]
                ? callback(this.config[key])
                : get(config.json_file(this.intl(key, lang))).then((ret: any) => {
                    this.config[key] = ret;
                    callback(ret);
                });

        }
    };
    /**
     * 国际化
     */
    intl = (key: string, lang?: string) => {
        switch (key) {
            case 'location':
                return ({
                    'zh-CN': '/global/position_zh_CN0421.json',
                    'zh-TW': '/global/position_zh_TW0421.json'
                } as any)[lang || languages.getDefault()] || '/global/position_en_US0421.json';
            case 'area':
                return ({
                    'zh-CN': '/global/phone_area_code_sc20191120.json',
                    'zh-TW': '/global/phone_area_code_tc20191120.json'
                } as any)[lang || languages.getDefault()] || '/global/phone_area_code_en20191106.json';
            // case 'phoneCodes':
            //     return ({
            //         'zh-CN': '/objects/phone_area_code_sc20191120.json',
            //         'zh-TW': '/objects/phone_area_code_tc20191120.json'
            //     } as any)[lang || languages.getDefault()] || '/objects/phone_area_code_en20191106.json';
            // 阿里云地域列表
            case 'aliCloudArea':
                return ({
                    'zh-CN': '/global/ali_area_sc_20200723.json',
                    'zh-TW': '/global/ali_area_tc_20200723.json'
                } as any)[lang || languages.getDefault()] || '/global/ali_area_en_20200723.json';
            default:
                return this.sourceMap[key];
        }
    };
    /**
     * 初始化静态资源
     */
    initData = (keys: Array<string>) => {
        keys.forEach((key: string) => {
            this.get(key, (ret: any) => {
                this.config[key] = ret;
            });
        });
    };

    /**
     * 获取多个key
     */
    index = (keys: Array<string> | string) => {
        const fields = Array.isArray(keys) ? keys : [keys];
        return Promise.all(fields.map(async (key: string) => {
            if (!this.config[key]) {
                let data;
                switch (key) {
                    case 'phoneCodes':
                        data = await ControlApi.country({lang: languages.getDefault()}).then((list: any) =>
                            list.map(({value, phoneCode, id, label }: any) => ({countryKey: value, value: phoneCode, key: id, name: label, phone_code: phoneCode}))
                        );
                        data = this.formatCountry(this.DEFALUTCOUNTRY, this.sortByLang(languages.getDefault(), data));
                        break;
                    case 'area':
                        data = await ControlApi.country({lang: languages.getDefault()});
                        break;
                    default:
                        data = await get(config.json_file(this.intl(key)));
                }
                this.config[key] = data;
            }
            return this.config[key];
        }));
    };
}

export default new Statics();
